import React, { useState, useEffect } from "react";
import axios from "axios";
import { parseISO, format } from "date-fns";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { JdsButton } from "../../components/jds/JdsButton";
import { EyeIcon, PlusIcon } from "../../components/jds/icons";
import { jdsTableStyles } from "../../components/jds/tableStyles";
import "../../components/jds/jds.css";
import "./consultas.css";
import { BlackListModal } from "./components/BlackListModal";
import { BlackList } from "./components/BlackList";
import { ConsultasModal } from "./components/ConsultasModal";

export function Consultas() {
  const [modalLogsOpen, setModalLogsOpen] = useState(false);
  const [logs, setLogs] = useState({});
  const [data, setData] = useState([]);
  const [isBlackList, setIsBlackList] = useState(false);
  const [blackListData, setBlackListData] = useState([]);
  const [isOperating, setIsOperating] = useState(false);
  const [isCreateBlackListModalOpen, setIsCreateBlackListModalOpen] = useState(
    false
  );
  const [needRefetch, setNeedRefetch] = useState(false);
  const getConsultas = async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/queries/list_error_queries"
    );
    setData(response.data.data);
  };
  const getBlackList = async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/black_list_document"
    );
    setBlackListData(response.data.data);
  };

  useEffect(() => {
    getConsultas();
    getBlackList();
  }, []);

  const openLogs = query => {
    setLogs({
      query_response: query.query_response,
      query_response_plain: query.query_response
    });
    setModalLogsOpen(true);
  };

  const whatsapp = phone => {
    const phoneOnlyNumbers = phone
      .replace("(", "")
      .replace(")", "")
      .replace("-", "")
      .replace(" ", "");
    const phoneInternational = `55${phoneOnlyNumbers}`;

    window.open(
      `https://api.whatsapp.com/send?phone=${phoneInternational}&text=`,
      "_blank"
    );
  };
  const handleOpenAttachment = url => {
    window.open(url, "_blank", "noopener noreferrer");
  };

  const handleDeleteDocument = async id => {
    if (!window.confirm("Tem certeza que deseja excluir este documento?"))
      return;

    try {
      setIsOperating(true);

      await axios.delete(
        `${process.env.REACT_APP_API_URL}/black_list_document/${id}`
      );

      setBlackListData(prevData => prevData.filter(item => item.id !== id));
    } catch (error) {
      toast.error("Erro ao excluir documento");
    } finally {
      setIsOperating(false);
    }
  };

  const handleActivateDocument = async (id, active) => {
    try {
      setIsOperating(true);

      await axios.patch(
        `${process.env.REACT_APP_API_URL}/black_list_document/${id}`,
        { active: !active }
      );

      setBlackListData(prevData =>
        prevData.map(item =>
          item.id === id ? { ...item, active: !active } : item
        )
      );
      toast.success("Sucesso ao alterar status do documento");
    } catch (error) {
      toast.error("Erro ao ativar/inativar documento");
    } finally {
      setIsOperating(false);
    }
  };

  useEffect(() => {
    if (needRefetch) {
      getBlackList();
      setNeedRefetch(false);
    }
  }, [needRefetch]);

  const columns = [
    {
      name: "Consultado em",
      cell: query => format(parseISO(query.created_at), "dd/MM/yyyy HH:mm"),
      width: "160px"
    },
    {
      name: "Cliente",
      cell: query => query.name,
      wrap: true,
      width: "200px"
    },
    {
      name: "E-mail",
      cell: query => query.email,
      wrap: true,
      width: "240px"
    },
    {
      name: "Telefone",
      cell: query => (
        <button
          type="button"
          className="consultas-link"
          onClick={() => whatsapp(query.phone)}
        >
          {query.phone}
        </button>
      ),
      width: "160px"
    },
    {
      name: "Documento consultado",
      cell: query => query.document,
      wrap: true,
      width: "200px"
    },
    {
      name: "Tipo da consulta",
      cell: query => query.query_type,
      wrap: true,
      width: "180px"
    },
    {
      name: "Pagamento?",
      cell: query =>
        `${query.payment_id == null ? "Não" : "Sim"} ${
          !query.status ? "" : " - " + query.status
        }`,
      wrap: true,
      width: "160px"
    },
    {
      name: "Logs",
      cell: query => (
        <JdsButton
          variant="ghost"
          color="neutral"
          size="sm"
          iconOnly
          aria-label="Ver logs"
          title="Ver logs"
          onClick={() => openLogs(query)}
        >
          <EyeIcon />
        </JdsButton>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      width: "80px"
    }
  ];

  return (
    <div className="jds-scope">
      <ConsultasModal
        show={modalLogsOpen}
        title="Logs da consulta"
        titleId="consultas-logs-modal-title"
        onClose={() => setModalLogsOpen(false)}
      >
        {logs && logs.query_response && (
          <div className="consultas-modal__section">
            <h3 className="jds-title-xs consultas-modal__section-title">
              Resposta
            </h3>
            <pre>{JSON.stringify(logs.query_response, null, 2)}</pre>
          </div>
        )}
        {logs && logs.query_response_plain && (
          <div className="consultas-modal__section">
            <h3 className="jds-title-xs consultas-modal__section-title">
              Texto simples
            </h3>
            <pre>{JSON.stringify(logs.query_response_plain, null, 2)}</pre>
          </div>
        )}
      </ConsultasModal>
      <BlackListModal
        isCreateBlackListModalOpen={isCreateBlackListModalOpen}
        setIsCreateBlackListModalOpen={setIsCreateBlackListModalOpen}
        getBlackList={getBlackList}
        setNeedRefetch={setNeedRefetch}
        needRefetch={needRefetch}
      />
      <h1 className="jds-title-lg">Consultas</h1>
      <p className="text-muted mb-10">Consultas Jusfinder</p>

      <div className="consultas-toolbar">
        <JdsButton
          variant="outlined"
          color="neutral"
          onClick={() => setIsBlackList(!isBlackList)}
        >
          Ir para {isBlackList ? "consultas" : "blacklist de documentos"}
        </JdsButton>
        {isBlackList && (
          <JdsButton onClick={() => setIsCreateBlackListModalOpen(true)}>
            <PlusIcon />
            Criar documento na blacklist
          </JdsButton>
        )}
      </div>
      {!isBlackList && (
        <div className="jds-card jds-card--flush">
          <div className="consultas-card__header">
            <h2 className="jds-title-md">Consultas com erro</h2>
          </div>
          <div style={{ overflowX: "auto", width: "100%" }}>
            <DataTable
              columns={columns}
              data={data || []}
              customStyles={jdsTableStyles}
              noDataComponent={
                <div className="consultas-empty">Nenhuma consulta com erro</div>
              }
              responsive={false}
              style={{ width: "100%" }}
            />
          </div>
        </div>
      )}
      {isBlackList && (
        <BlackList
          blackListData={blackListData}
          handleOpenAttachment={handleOpenAttachment}
          handleActivateDocument={handleActivateDocument}
          handleDeleteDocument={handleDeleteDocument}
          isOperating={isOperating}
        />
      )}
    </div>
  );
}
